import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './LoadingSpinner.scss';
function LoadingSpinner({ size = '80px' }) {
    const style = { width: `${size}`, height: `${size}` };
    return (_jsxs("div", Object.assign({ className: "lds-ring", style: style }, { children: [_jsx("div", { style: style }), _jsx("div", { style: style }), _jsx("div", { style: style }), _jsx("div", { style: style })] })));
}
export default LoadingSpinner;
